import React, { useState } from "react";
import TitleText from "./utils/TitleText";

const Contact = () => {
	const [form, setForm] = useState({ name: "", email: "", message: "" });

	const handleChange = (e) =>
		setForm({ ...form, [e.target.name]: e.target.value });

	const handleSubmit = (e) => {
		e.preventDefault();
		alert("Thanks for reaching out!");
	};

	return (
		<section className="py-20 flex flex-col items-center" id="contact">
			<TitleText title="Contact Us" />

			<div className="flex gap-8 mt-10">
				<div className="px-4 md:basis-1/2">
					<h3 className="text-3xl font-semibold mb-6">
						Send us a Message or schedule a consultation
					</h3>
					<form className="space-y-4" onSubmit={handleSubmit}>
						<input
							type="text"
							name="name"
							placeholder="Your Name"
							className="w-full p-3 border border-gray-300 rounded"
							value={form.name}
							onChange={handleChange}
							required
						/>
						<input
							type="email"
							name="email"
							placeholder="Your Email"
							className="w-full p-3 border border-gray-300 rounded"
							value={form.email}
							onChange={handleChange}
							required
						/>
						<textarea
							name="message"
							placeholder="Your Message"
							className="w-full p-3 border border-gray-300 rounded"
							rows="5"
							value={form.message}
							onChange={handleChange}
							required
						/>
						<button
							type="submit"
							className="bg-violet-700 text-white px-6 py-3 rounded hover:bg-violet-800"
						>
							Send Message
						</button>
					</form>
				</div>

				<div className="basis-1/2 hidden md:block me-4">
					<img
						src="https://www.softwebsolutions.com/wp-content/uploads/2023/12/AI-in-call-center.webp"
						alt="image-contactus"
						className="rounded-lg shadow-lg w-full h-full object-cover"
					/>
				</div>
			</div>
		</section>
	);
};

export default Contact;
